module.exports = __webpack_public_path__ + "img/main-gallery2.bbde5525.webp";